import {
  FormatOption,
  FormatOption_Percent,
} from 'src/modals/EditTableColumns';
import { ReportColumnPersonalizationFlags } from 'src/utils/columns/columnUtils.types';
import { isCustomColumnName } from 'src/utils/columns/reportV2CustomColumnUtils';

export const getIsPercentFlagForReportColumn = ({
  columnId,
  personalizationConfigOverrides,
  precision,
}: {
  columnId: string;
  personalizationConfigOverrides: Record<
    string,
    Partial<ReportColumnPersonalizationFlags>
  >;
  precision: FormatOption | undefined;
}) => {
  let isPercent = personalizationConfigOverrides[columnId]?.isPercent;

  const isPercentOption =
    precision &&
    Object.values(FormatOption_Percent).includes(
      precision as FormatOption_Percent
    );

  const isCustomColumn = isCustomColumnName(columnId);
  if (isCustomColumn && isPercentOption) {
    // If the column is a custom column, and user picks a percent option
    // we should respect the user's choice
    isPercent = true;
  }

  return isPercent;
};
